import React, { useRef } from 'react';

import { AudioCaptionsContextProvider } from '../../../components/Audio/AudioCaptionsContextProvider';
import { FullScreenContentModal } from '../../../components/modal/FullScreenContentModalNavigation/FullScreenContentModal';
import { useStartingMessage } from '../../../hooks/useStartingMessage';
import { MemoizedContentRequirementsProvider } from '../../RestrictNavigation/ContentRequirementsProvider';
import { CSSTransition } from 'react-transition-group';
import { FroalaEditorsSettings } from 'src/config/configs';

export const StartingMessageModal: React.FC<{ froalaEditorsSettings: FroalaEditorsSettings }> = ({ froalaEditorsSettings }) => {
  const { item, visible, onDismiss } = useStartingMessage();
  const ref = useRef(null);

  return (
    <CSSTransition
      nodeRef={ref}
      classNames="fade"
      timeout={450}
      in={!!item && visible}
      appear={true}
      unmountOnExit={true}
      key={item?.id || ''}
    >
      <>
        {item && onDismiss && (
          <AudioCaptionsContextProvider>
            <MemoizedContentRequirementsProvider item={item}>
              <FullScreenContentModal ref={ref} contentItem={item} onContinue={onDismiss} froalaEditorsSettings={froalaEditorsSettings} />
            </MemoizedContentRequirementsProvider>
          </AudioCaptionsContextProvider>
        )}
      </>
    </CSSTransition>
  );
};
